(function(document, tag) {
    var scriptTag = document.createElement(tag), // create a script tag
        firstScriptTag = document.getElementsByTagName(tag)[0]; // find the first script tag in the document
    scriptTag.src = 'https://ajax.googleapis.com/ajax/libs/jquery/3.4.1/jquery.min.js'; // set the source of the script to your script
    firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag); // append the script to the DOM
}(document, 'script'));


document.addEventListener('DOMContentLoaded', function() {
    document.getElementById('menu-close-new').addEventListener('click', function() {
        document.querySelectorAll('.header__icon--menu')[0].click();
    });
});


var ur = window.location.href;
if(ur.includes('/product')){
  jQuery(document).ready(function(){

     setInterval(function(){ 
var x = parseInt(jQuery('span.slider-counter--current').eq(0).html()) - 1;
     jQuery('.dots-section .dot').removeClass('selected')  ;
jQuery('.dots-section .dot').eq(x).addClass('selected');
}, 50);

    $('.size-selector').click(function(){
    $('.size-selector').removeClass('selected');
    $(this).addClass('selected');
    $('[data-class="size-table"]').removeAttr('selected');
    $('[data-class="size-table"][table-title="'+$(this).attr('id')+'"]').attr('selected', true);
}); 

    $('a.mocycle-find-size-link').click(function(e){
  e.preventDefault();
   $('.product-popup-modal__opener[data-title="Size Guide"] button').eq(0).click(); 
}); 

    if($('.mocycle-checkbox:checked').length){
    console.log('checked');
    jQuery('[data-title="Function"] label').eq(0).click()
  }
  else{
    jQuery('[data-title="Function"] label').eq(1).click()
  }
$('input.mocycle-checkbox').click(function(){
  if($('.mocycle-checkbox:checked').length){
    console.log('checked');
    jQuery('[data-title="Function"] label').eq(0).click()
    
  }
  else{
    jQuery('[data-title="Function"] label').eq(1).click()
  }
}); 
});
}

